import { render } from "./MapYourAreas.vue?vue&type=template&id=ce54405e&scoped=true"
import script from "./MapYourAreas.vue?vue&type=script&lang=js"
export * from "./MapYourAreas.vue?vue&type=script&lang=js"

import "./MapYourAreas.vue?vue&type=style&index=0&id=ce54405e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce54405e"]])

export default __exports__